import React from "react";
import Typography from "@visa/vds/typography";
import Row from "@visa/vds/row";
import Col from "@visa/vds/col";
import Accordion from "@visa/vds/accordion";
import AccordionBody from "@visa/vds/accordion-body";
import AccordionItem from "@visa/vds/accordion-item";
import AccordionHeading from "@visa/vds/accordion-heading";
import AccordionTitle from "@visa/vds/accordion-title";
import Fieldset from "@visa/vds/fieldset";
import Form from "@visa/vds/form";
import FormControl from "@visa/vds/form-control";
import Input from "@visa/vds/input";
import "flag-icon-css/css/flag-icon.min.css";
import Select from "@visa/vds/select";
import InputOption from "@visa/vds/input-option";
import { DEFAULT_COUNTRY_CODE } from "../../../_constants/GlobalConstants";
import Checkbox from "@visa/vds/checkbox";
import CheckboxList from "@visa/vds/checkbox-list";
import CheckboxListItem from "@visa/vds/checkbox-list-item";

function CompanyInfoSection(props) {

  const toggleIsMerchant = () => {
    props.setOrganization({
      ...props.organization,
      isMerchant: !props.organization.isMerchant,
    });
  };

  React.useEffect(() => { }, []);
  return (
    <>
      <Accordion id="accordion-coy-info" defaultExpandedId={[0]}>
        <AccordionItem>
          <AccordionHeading>
            <AccordionTitle>Company Information</AccordionTitle>
          </AccordionHeading>
          <AccordionBody>
            <Row>
              <Col>
                <Typography className="vss-field-label">
                  <b>Name</b>
                </Typography>
                <Typography className="vss-field-value">
                  {props.organization && props.organization.organizationName}
                </Typography>

                <Typography className="vss-field-label">
                  <b>BID</b>
                </Typography>
                <Typography className="vss-field-value">
                  {props.organization && props.organization.bid != null
                    ? props.organization.bid
                    : "-"}
                </Typography>

                <Typography className="vss-field-label">
                  <b>Region</b>
                </Typography>
                <Typography className="vss-field-value">
                  {props.organization && props.organization.regionName}
                </Typography>

                <Typography className="vss-field-label">
                  <b>Country</b>
                </Typography>
                <Typography className="vss-field-value">
                  {props.organization && props.organization.country.countryName}
                </Typography>

                <Form style={{ marginTop: "-10px" }}>
                  <FormControl position="left" space="fifty">
                    <Input
                      label="Company URL"
                      name="company-url"
                      value={
                        props.organization &&
                          props.organization.companyUrl != null
                          ? props.organization.companyUrl
                          : ""
                      }
                      onChange={(e) =>
                        props.setOrganization({
                          ...props.organization,
                          companyUrl: e.target.value,
                        })
                      }
                    />
                  </FormControl>
                  <FormControl>
                    <CheckboxList>
                      <CheckboxListItem>
                        <Checkbox
                          disabled={!props.user.isSuperAdmin}
                          checked={props.organization.isMerchant}
                          onChange={toggleIsMerchant}
                          label={"This organization is a Merchant."}
                          name="checkbox-isMerchant"
                        />
                      </CheckboxListItem>
                    </CheckboxList>
                  </FormControl>
                </Form>
              </Col>
              <Col>
                <Form>
                  <Fieldset>
                    <legend>
                      <b>Address</b>
                    </legend>
                    <FormControl>
                      <Input
                        label="First Name"
                        name="first-name"
                        value={
                          props.organization &&
                            props.organization.repFirstName != null
                            ? props.organization.repFirstName
                            : ""
                        }
                        onChange={(e) =>
                          props.setOrganization({
                            ...props.organization,
                            repFirstName: e.target.value,
                          })
                        }
                      />
                    </FormControl>
                    <FormControl>
                      <Input
                        label="Last Name"
                        name="last-name"
                        value={
                          props.organization &&
                            props.organization.repLastName != null
                            ? props.organization.repLastName
                            : ""
                        }
                        onChange={(e) =>
                          props.setOrganization({
                            ...props.organization,
                            repLastName: e.target.value,
                          })
                        }
                      />
                    </FormControl>
                    <FormControl>
                      <Select
                        style={{ height: "auto" }}
                        label="Country/Region"
                        fullwidth
                        value={
                          props.organization &&
                            props.organization.repCountryCode != null
                            ? props.organization.repCountryCode
                            : DEFAULT_COUNTRY_CODE
                        }
                        onChange={(e) =>{
                          console.log(e.target.value)
                          props.setOrganization({
                            ...props.organization,
                            repCountryCode: e.target.value,
                          })
                        }
                        }
                      >
                        {props.countries &&
                          props.countries.map((country, k) => (
                            <option key={k} value={country.id}>
                              {country.countryName.trim()}
                            </option>
                          ))}
                      </Select>
                    </FormControl>
                    <FormControl>
                      <Input
                        label="Address Line 1"
                        name="address-line-1"
                        value={
                          props.organization &&
                            props.organization.repAddressLineOne != null
                            ? props.organization.repAddressLineOne
                            : ""
                        }
                        onChange={(e) =>
                          props.setOrganization({
                            ...props.organization,
                            repAddressLineOne: e.target.value,
                          })
                        }
                      />
                    </FormControl>
                    <FormControl>
                      <Input
                        label="Address Line 2"
                        name="address-line-2"
                        value={
                          props.organization &&
                            props.organization.repAddressLineTwo != null
                            ? props.organization.repAddressLineTwo
                            : ""
                        }
                        onChange={(e) =>
                          props.setOrganization({
                            ...props.organization,
                            repAddressLineTwo: e.target.value,
                          })
                        }
                      />
                    </FormControl>
                    <FormControl>
                      <Input
                        label="City"
                        name="City"
                        value={
                          props.organization &&
                            props.organization.repCity != null
                            ? props.organization.repCity
                            : ""
                        }
                        onChange={(e) =>
                          props.setOrganization({
                            ...props.organization,
                            repCity: e.target.value,
                          })
                        }
                      />
                    </FormControl>
                    <FormControl position="right" space="fifty">
                      <Input
                        label="State"
                        name="state"
                        value={
                          props.organization &&
                            props.organization.repState != null
                            ? props.organization.repState
                            : ""
                        }
                        onChange={(e) =>
                          props.setOrganization({
                            ...props.organization,
                            repState: e.target.value,
                          })
                        }
                      />
                    </FormControl>
                    <FormControl position="right" space="fifty">
                      <Input
                        label="Zip Code"
                        name="Zip"
                        value={
                          props.organization &&
                            props.organization.repZipCode != null
                            ? props.organization.repZipCode
                            : ""
                        }
                        onChange={(e) =>
                          props.setOrganization({
                            ...props.organization,
                            repZipCode: e.target.value,
                          })
                        }
                      />
                    </FormControl>
                    <FormControl>
                      <Input
                        label="Country Code"
                        name="country-code"
                        value={
                          props.organization &&
                            props.organization.repCountryPhoneCode != null
                            ? props.organization.repCountryPhoneCode
                            : ""
                        }
                        onChange={(e) =>
                          props.setOrganization({
                            ...props.organization,
                            repCountryPhoneCode: e.target.value,
                          })
                        }
                      />
                    </FormControl>
                    <FormControl>
                      <Input
                        label="Phone Number"
                        name="phone-no"
                        value={
                          props.organization &&
                            props.organization.phoneNumber != null
                            ? props.organization.phoneNumber
                            : ""
                        }
                        onChange={(e) =>
                          props.setOrganization({
                            ...props.organization,
                            phoneNumber: e.target.value,
                          })
                        }
                      />
                    </FormControl>
                  </Fieldset>
                </Form>
              </Col>
            </Row>
          </AccordionBody>
        </AccordionItem>
      </Accordion>
    </>
  );
}

export default CompanyInfoSection;
